let videos = document.querySelectorAll('.js-embed-video');
if(videos.length >= 1){
    for (var i = 0; i < videos.length; i++) {
        videos[i].addEventListener('click', function() {
            var iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/'+ this.dataset.videoid +'?autoplay=1');
            this.innerHTML = '';
            this.appendChild(iframe);
            this.classList.remove('video-overlay')
            event.preventDefault();
        });
    };
}

let videosUpload = document.querySelectorAll('.js-upload-video');
if(videosUpload.length >= 1){
    for (var i = 0; i < videosUpload.length; i++) {
        videosUpload[i].addEventListener('click', function() {
            this.firstElementChild.classList.remove('hidden')
            this.firstElementChild.play()
            this.classList.remove('video-overlay')
            event.preventDefault();
        }, { once: true });
    };
}

